import { Edit } from "@refinedev/mui";
import type { HttpError } from "@refinedev/core";
import { useForm } from "@refinedev/react-hook-form";
import { GemPackFields } from "./form";
import { editableOf, type GemPackFormValues } from "./values";

export const CreditBundleEdit = () => {
  const {
    saveButtonProps,
    refineCore: { onFinish },
    handleSubmit,
    control,
    register,
    formState: { errors },
  } = useForm<GemPackFormValues, HttpError, GemPackFormValues>({});

  return (
    <Edit
      title="Edit Credits Pack"
      saveButtonProps={{
        ...saveButtonProps,
        // Only what an edit may change: the record's id, key and timestamps are never sent back.
        onClick: handleSubmit((values) => onFinish(editableOf(values))),
      }}
    >
      <GemPackFields control={control} register={register} errors={errors} keyLocked />
    </Edit>
  );
};
